module.exports = __webpack_public_path__ + "static/media/manual_03.1b5c9010.jpg";